import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";
import { useToasts, dismiss } from "@/lib/toast";

const CONF = {
  error: { Icon: AlertCircle, cls: "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-500/30 dark:bg-rose-500/10 dark:text-rose-200" },
  success: { Icon: CheckCircle2, cls: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-200" },
  info: { Icon: Info, cls: "border-brand-200 bg-brand-50 text-brand-700 dark:border-brand-500/30 dark:bg-brand-500/10 dark:text-brand-200" },
};

// App-wide toast stack. Mount once at the root; renders whatever lib/toast holds.
export default function Toaster() {
  const toasts = useToasts();
  if (!toasts.length) return null;
  return (
    // Cleared above the Assistant bubble (fixed bottom-5 right-5, h-14): the two
    // shared a corner, so a toast landed on top of the chat launcher — and any
    // toast rendered below its z-index disappeared underneath it entirely.
    <div className="pointer-events-none fixed bottom-24 left-1/2 z-[100] flex w-[min(24rem,calc(100vw-2rem))] -translate-x-1/2 flex-col gap-2 sm:left-auto sm:right-5 sm:translate-x-0">
      {toasts.map((t) => {
        const { Icon, cls } = CONF[t.type] || CONF.info;
        return (
          <div
            key={t.id}
            role="alert"
            className={`pointer-events-auto flex items-start gap-2.5 rounded-xl border px-3.5 py-3 text-sm shadow-soft backdrop-blur ${cls}`}
          >
            <Icon size={18} className="mt-0.5 shrink-0" />
            <span className="min-w-0 flex-1 break-words">{t.message}</span>
            <button
              type="button"
              onClick={() => dismiss(t.id)}
              aria-label="Dismiss"
              className="shrink-0 opacity-70 transition hover:opacity-100"
            >
              <X size={15} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
